import {
  START_GET_PATIENT_LIST,
  SUCCESS_GET_PATIENT_LIST,
  ERROR_GET_PATIENT_LIST,
  START_CREATE_PATIENT,
  SUCCESS_CREATE_PATIENT,
  ERROR_CREATE_PATIENT,
  START_UPDATE_PATIENT,
  SUCCESS_UPDATE_PATIENT,
  ERROR_UPDATE_PATIENT,
  START_GET_SINGLE_PATIENT,
  SUCCESS_GET_SINGLE_PATIENT,
  ERROR_GET_SINGLE_PATIENT,
  START_DELETE_PATIENT,
  SUCCESS_DELETE_PATIENT,
  ERROR_DELETE_PATIENT,
  START_GET_SURGERY_FIELD_LIST,
  SUCCESS_GET_SURGERY_FIELD_LIST,
  ERROR_GET_SURGERY_FIELD_LIST,
  START_PHARMACY_LIST,
  SUCCESS_PHARMACY_LIST,
  ERROR_PHARMACY_LIST,
  START_DRUG_LIST,
  SUCCESS_DRUG_LIST,
  ERROR_GURG_LIST,
  START_GROUP_FIELD_LIST,
  SUCCESS_GROUP_FIELD_LIST,
  ERROR_GROUP_FIELD_LIST,
  START_PATIENT_URGENCY_STATUS_CHANGE,
  SUCCESS_PATIENT_URGENCY_STATUS_CHANGE,
  ERROR_PATIENT_URGENCY_STATUS_CHANGE,
  START_CREATE_PATIENT_NOTE,
  SUCCESS_CREATE_PATIENT_NOTE,
  ERROR_CREATE_PATIENT_NOTE,
  START_UPDATE_PATIENT_NOTE,
  SUCCESS_UPDATE_PATIENT_NOTE,
  ERROR_UPDATE_PATIENT_NOTE,
  START_DELETE_PATIENT_NOTE,
  SUCCESS_DELETE_PATIENT_NOTE,
  ERROR_DELETE_PATIENT_NOTE,
  START_GET_PATIENT_NOTE_LIST,
  SUCCESS_GET_PATIENT_NOTE_LIST,
  ERROR_GET_PATIENT_NOTE_LIST,
  START_GET_SINGLE_PATIENT_NOTE,
  SUCCESS_GET_SINGLE_PATIENT_NOTE,
  ERROR_GET_SINGLE_PATIENT_NOTE,
  START_GET_PATIENT_MEDICATION_HISTORY_LIST,
  SUCCESS_GET_PATIENT_MEDICATION_HISTORY_LIST,
  ERROR_GET_PATIENT_MEDICATION_HISTORY_LIST,
  START_CREATE_PATIENT_SURGERY,
  SUCCESS_CREATE_PATIENT_SURGERY,
  ERROR_CREATE_PATIENT_SURGERY,
  START_IMPORT_CSV,
  SUCCESS_IMPORT_CSV,
  ERROR_IMPORT_CSV,
  START_GET_IMPORT_CSV_LIST,
  SUCCESS_GET_IMPORT_CSV_LIST,
  ERROR_GET_IMPORT_CSV_LIST,
  START_DELETE_MULTIPLE_AND_SINGLE_CSV,
  SUCCESS_DELETE_MULTIPLE_AND_SINGLE_CSV,
  ERROR_DELETE_MULTIPLE_AND_SINGLE_CSV,
  START_STATUS_PATIENT_UPDATE,
  SUCCESS_STATUS_PATIENT_UPDATE,
  ERROR_STATUS_PATIENT_UPDATE,
  START_UPDATE_FIELD_PATIENT,
  SUCCESS_UPDATE_FIELD_PATIENT,
  ERROR_UPDATE_FIELD_PATIENT,
  START_ARCHIVE_MEDICATION,
  SUCCESS_ARCHIVE_MEDICATION,
  ERROR_ARCHIVE_MEDICATION,
  SUCCESS_PROFILE_UPDATE,
  ERROR_PROFILE_UPDATE,
  START_PROFILE_UPDATE,
  SUCCESS_PATIENT_MULTI_DELETE,
  ERROR_PATIENT_MULTI_DELETE,
  START_PATIENT_MULTI_DELETE,
  START_GET_IMPORT_PATIENT_DUPLICATE,
  SUCCESS_GET_IMPORT_PATIENT_DUPLICATE,
  ERROR_GET_IMPORT_PATIENT_DUPLICATE,
  START_IMPORT_PATIENT_DUPLICATE_DELETE,
  SUCCESS_IMPORT_PATIENT_DUPLICATE_DELETE,
  ERROR_IMPORT_PATIENT_DUPLICATE_DELETE,
  START_PATIENT_ALL_DELETE,
  SUCCESS_PATIENT_ALL_DELETE,
  ERROR_PATIENT_ALL_DELETE,
} from "Actions/PatientAction";
import { ADD_NEW_NOTIFICATION } from "Actions/ConfigAction";
import {
  getPatientListAPI,
  createPatientAPI,
  updatePatientAPI,
  updatePatientFieldAPI,
  getSinglePatient,
  deletePatientAPI,
  getSurgeryFieldListAPI,
  getPharmacyListAPI,
  getGroupFieldListAPI,
  patientUrgencyStatus,
  getPatientNoteListAPI,
  createPatientNoteAPI,
  updatePatientNoteAPI,
  deletePatientNoteAPI,
  getSinglePatientNote,
  getPatientMedicationHistoryAPI,
  getDrugsListAPIFromDND,
  importCSVFile,
  getImportListAPI,
  deleteMultipleAndSingleCsvListAPI,
  archiveMedicationAPI,
  profileUpdateAPI,
  pateintDeleteMultiple,
  getPateintImportDuplicate,
  importDuplicateDelete,
  getPatientDeleteCount,
} from "Api/PatientApi";
import { createSurgeryAPI } from "Api/SurgeryApi";
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { statusUpdateAPI } from "Api/RepeatOrderApis";

function* getPatientListWorker({ payload }) {
  try {
    const res = yield call(getPatientListAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_PATIENT_LIST,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_PATIENT_LIST,
        payload: res,
      });
    }
  } catch (error) {}
}

function* createPatientListWorker({ payload }) {
  try {
    const res = yield call(createPatientAPI, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_CREATE_PATIENT,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Patient Created Successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_CREATE_PATIENT,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message:
            res.errors.temp_patient_id[0] !== undefined
              ? res.errors.temp_patient_id[0]
              : res.message,
          type: "error",
        },
      });
    }
  } catch (error) {}
}

function* updatePatientWorker({ id, payload }) {
  try {
    const res = yield call(updatePatientAPI, id, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_UPDATE_PATIENT,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Patient Updated successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_UPDATE_PATIENT,
        payload: res,
      });
    }
  } catch (error) {}
}

function* updatePatientFieldWorker({ id, payload }) {
  try {
    const res = yield call(updatePatientFieldAPI, id, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_UPDATE_FIELD_PATIENT,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Patient Updated successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_UPDATE_FIELD_PATIENT,
        payload: res,
      });
    }
  } catch (error) {}
}

function* getSinglePatientWorker({ id }) {
  try {
    const res = yield call(getSinglePatient, id);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_SINGLE_PATIENT,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_SINGLE_PATIENT,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: res.errors.id[0],
          type: "error",
        },
      });
    }
  } catch (error) {}
}

function* deletePatientWorker({ id }) {
  try {
    const res = yield call(deletePatientAPI, id);
    if (res.success) {
      yield put({
        type: SUCCESS_DELETE_PATIENT,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Patient deleted successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_DELETE_PATIENT,
        payload: res,
      });
    }
  } catch (error) {}
}

function* getSurgeryFieldListWorker({ payload }) {
  try {
    const res = yield call(getSurgeryFieldListAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_SURGERY_FIELD_LIST,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_SURGERY_FIELD_LIST,
        payload: res,
      });
    }
  } catch (error) {}
}

function* getPharmacyListWorker({ payload }) {
  try {
    const res = yield call(getPharmacyListAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_PHARMACY_LIST,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_PHARMACY_LIST,
        payload: res,
      });
    }
  } catch (error) {}
}

function* getDrugListWorker({ payload }) {
  try {
    const res = yield call(getDrugsListAPIFromDND, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_DRUG_LIST,
        payload: res,
        // page: payload.page,
        page: (payload.offset / 10),
      });
    } else {
      yield put({
        type: ERROR_GURG_LIST,
        payload: res,
      });
    }
  } catch (error) {}
}

function* getGroupFieldListWorker({ payload }) {
  try {
    const res = yield call(getGroupFieldListAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_GROUP_FIELD_LIST,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GROUP_FIELD_LIST,
        payload: res,
      });
    }
  } catch (error) {}
}

function* urgencyPatientStatusWorker({ id, payload }) {
  try {
    const res = yield call(patientUrgencyStatus, id, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_PATIENT_URGENCY_STATUS_CHANGE,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Patient urgency status updated successfully.",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_PATIENT_URGENCY_STATUS_CHANGE,
        payload: res,
      });
    }
  } catch (error) {}
}

//Pateint Note list
function* getPatientNoteListWorker({ payload }) {
  try {
    const res = yield call(getPatientNoteListAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_PATIENT_NOTE_LIST,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_PATIENT_NOTE_LIST,
        payload: res,
      });
    }
  } catch (error) {}
}

//Patient Note Create
function* createPatientNoteWorker({ payload }) {
  try {
    const res = yield call(createPatientNoteAPI, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_CREATE_PATIENT_NOTE,
        payload: res,
        requestPayload: payload,
        patient_id: payload?.patient_id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Patient note added successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_CREATE_PATIENT_NOTE,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: res.message,
          type: "error",
        },
      });
    }
  } catch (error) {}
}

//Update Patient Note
function* updatePatientNoteWorker({ id, payload }) {
  try {
    const res = yield call(updatePatientNoteAPI, id, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_UPDATE_PATIENT_NOTE,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Patient note updated successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_UPDATE_PATIENT_NOTE,
        payload: res,
      });
    }
  } catch (error) {}
}

//Delete Pateint note
function* deletePatientNoteWorker({ id, patient_id }) {
  try {
    const res = yield call(deletePatientNoteAPI, id);
    if (res.success) {
      yield put({
        type: SUCCESS_DELETE_PATIENT_NOTE,
        payload: res,
        id: id,
        patient_id: patient_id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Patient note deleted successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_DELETE_PATIENT_NOTE,
        payload: res,
      });
    }
  } catch (error) {}
}

function* getSinglePatientNoteListWorker({ id }) {
  try {
    const res = yield call(getSinglePatientNote, id);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_SINGLE_PATIENT_NOTE,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_SINGLE_PATIENT_NOTE,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: res.errors.id[0],
          type: "error",
        },
      });
    }
  } catch (error) {}
}

/* Patient medication history */
function* getPatientMedicationHistoryWorker({ id, payload }) {
  try {
    const res = yield call(getPatientMedicationHistoryAPI, id, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_PATIENT_MEDICATION_HISTORY_LIST,
        payload: res,
        id: id,
      });
    } else {
      yield put({
        type: ERROR_GET_PATIENT_MEDICATION_HISTORY_LIST,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: res.errors.id[0],
          type: "error",
        },
      });
    }
  } catch (error) {}
}

function* createSurgeryWorker({ payload }) {
  try {
    const res = yield call(createSurgeryAPI, payload);
    if (res?.success) {
      yield put({
        type: SUCCESS_CREATE_PATIENT_SURGERY,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Surgery Added Successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_CREATE_PATIENT_SURGERY,
        payload: res,
      });
    }
  } catch (error) {}
}

function* importCsvPatientWorker({ formData }) {
  try {
    const res = yield call(importCSVFile, formData);
    if (res.success) {
      yield put({
        type: SUCCESS_IMPORT_CSV,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: res.message,
        },
      });
    } else {
      yield put({
        type: ERROR_IMPORT_CSV,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: res.data.errors[0] || res.message,
          type: "error",
        },
      });
    }
  } catch (error) {}
}

function* getImportListAPIWorker({ payload }) {
  try {
    const res = yield call(getImportListAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_IMPORT_CSV_LIST,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_IMPORT_CSV_LIST,
        payload: res,
      });
    }
  } catch (error) {}
}

function* deleteMultipleAndSingleWorker({ payload }) {
  try {
    const res = yield call(deleteMultipleAndSingleCsvListAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_DELETE_MULTIPLE_AND_SINGLE_CSV,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Patient deleted successfully",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_DELETE_MULTIPLE_AND_SINGLE_CSV,
        payload: res,
      });
    }
  } catch (error) {}
}
function* patientStatusWorker({ payload, id }) {
  try {
    const res = yield call(statusUpdateAPI, id, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_STATUS_PATIENT_UPDATE,
        payload: res,
        id: id,
      });
    } else {
      yield put({
        type: ERROR_STATUS_PATIENT_UPDATE,
        payload: res,
      });
    }
  } catch (error) {}
}
function* archiveMedicationWorker({ id, payload, pateint_id, historyPayload }) {
  try {
    const res = yield call(archiveMedicationAPI, id);
    if (res.success) {
      yield put({
        type: SUCCESS_ARCHIVE_MEDICATION,
        payload: res,
        id: id,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Medication Unarchived successfully.",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_ARCHIVE_MEDICATION,
        payload: res,
      });
    }
  } catch (error) {}
}

function* profileUpdateWorker({ payload }) {
  try {
    const res = yield call(profileUpdateAPI, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_PROFILE_UPDATE,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Profile Updated successfully.",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_PROFILE_UPDATE,
        payload: res,
      });
    }
  } catch (error) {}
}
function* pateintDeleteMultipleWorker({ payload }) {
  try {
    const res = yield call(pateintDeleteMultiple, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_PATIENT_MULTI_DELETE,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Patients Deleted successfully.",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_PATIENT_MULTI_DELETE,
        payload: res,
      });
    }
  } catch (error) {}
}
function* getPatientListImportWorker({ payload }) {
  try {
    const res = yield call(getPateintImportDuplicate, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_GET_IMPORT_PATIENT_DUPLICATE,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_GET_IMPORT_PATIENT_DUPLICATE,
        payload: res,
      });
    }
  } catch (error) {}
}

function* importPateintDeleteMultipleWorker({ payload }) {
  try {
    const res = yield call(importDuplicateDelete, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_IMPORT_PATIENT_DUPLICATE_DELETE,
        payload: res,
      });
      yield put({
        type: ADD_NEW_NOTIFICATION,
        payload: {
          message: "Patients deleted successfully.",
          type: "success",
        },
      });
    } else {
      yield put({
        type: ERROR_IMPORT_PATIENT_DUPLICATE_DELETE,
        payload: res,
      });
    }
  } catch (error) {}
}
function* pateintMultipleDeleteWorker({ payload }) {
  try {
    const res = yield call(getPatientDeleteCount, payload);
    if (res.success) {
      yield put({
        type: SUCCESS_PATIENT_ALL_DELETE,
        payload: res,
      });
    } else {
      yield put({
        type: ERROR_PATIENT_ALL_DELETE,
        payload: res,
      });
    }
  } catch (error) {}
}

export function* PatientSaga() {
  yield takeLatest(START_GET_PATIENT_LIST, getPatientListWorker);
  yield takeEvery(START_CREATE_PATIENT, createPatientListWorker);
  yield takeEvery(START_UPDATE_PATIENT, updatePatientWorker);
  yield takeEvery(START_GET_SINGLE_PATIENT, getSinglePatientWorker);
  yield takeEvery(START_DELETE_PATIENT, deletePatientWorker);
  yield takeEvery(START_GET_SURGERY_FIELD_LIST, getSurgeryFieldListWorker);
  yield takeEvery(START_PHARMACY_LIST, getPharmacyListWorker);
  yield takeLatest(START_DRUG_LIST, getDrugListWorker);
  yield takeEvery(START_GROUP_FIELD_LIST, getGroupFieldListWorker);
  yield takeEvery(
    START_PATIENT_URGENCY_STATUS_CHANGE,
    urgencyPatientStatusWorker
  );
  yield takeEvery(START_CREATE_PATIENT_NOTE, createPatientNoteWorker);
  yield takeEvery(START_UPDATE_PATIENT_NOTE, updatePatientNoteWorker);
  yield takeEvery(START_DELETE_PATIENT_NOTE, deletePatientNoteWorker);
  yield takeEvery(START_GET_PATIENT_NOTE_LIST, getPatientNoteListWorker);
  yield takeEvery(
    START_GET_SINGLE_PATIENT_NOTE,
    getSinglePatientNoteListWorker
  );
  yield takeEvery(
    START_GET_PATIENT_MEDICATION_HISTORY_LIST,
    getPatientMedicationHistoryWorker
  );
  yield takeEvery(START_CREATE_PATIENT_SURGERY, createSurgeryWorker);
  yield takeEvery(START_IMPORT_CSV, importCsvPatientWorker);
  yield takeEvery(START_GET_IMPORT_CSV_LIST, getImportListAPIWorker);
  yield takeEvery(
    START_DELETE_MULTIPLE_AND_SINGLE_CSV,
    deleteMultipleAndSingleWorker
  );
  yield takeEvery(START_STATUS_PATIENT_UPDATE, patientStatusWorker);
  yield takeEvery(START_UPDATE_FIELD_PATIENT, updatePatientFieldWorker);
  yield takeEvery(START_ARCHIVE_MEDICATION, archiveMedicationWorker);
  yield takeEvery(START_PROFILE_UPDATE, profileUpdateWorker);
  yield takeEvery(START_PATIENT_MULTI_DELETE, pateintDeleteMultipleWorker);
  yield takeEvery(
    START_GET_IMPORT_PATIENT_DUPLICATE,
    getPatientListImportWorker
  );
  yield takeEvery(
    START_IMPORT_PATIENT_DUPLICATE_DELETE,
    importPateintDeleteMultipleWorker
  );
  yield takeEvery(START_PATIENT_ALL_DELETE, pateintMultipleDeleteWorker);
}
